import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#FFF",
  d: "m8.5 0 .001 2.01a5.987 5.987 0 0 1 3.75 1.74 5.987 5.987 0 0 1 1.74 3.749L16 7.5v1h-2.01a5.987 5.987 0 0 1-1.74 3.75 5.987 5.987 0 0 1-3.749 1.74L8.5 16h-1v-2.01a5.987 5.987 0 0 1-3.75-1.74A5.987 5.987 0 0 1 2.01 8.5H0v-1l2.01-.001a5.987 5.987 0 0 1 1.74-3.75A5.987 5.987 0 0 1 7.5 2.01V0h1zm2.988 4.512a4.932 4.932 0 1 0-6.976 6.976 4.932 4.932 0 0 0 6.976-6.976zM8 5.051a2.95 2.95 0 1 1 0 5.898 2.95 2.95 0 0 1 0-5.898z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }